
export const getLastSevenDays = (): string[] => {
  const dates = []

  for (let i = 6; i >= 0; i--) {
    const date = new Date()
    date.setDate(date.getDate() - i)

    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')

    dates.push(`${day}/${month}`)
  }

  return dates
}

export const getLastSixWeeks = (): string[] => {
  const weeks = []

  for (let i = 0; i < 6; i++) {
    const date = new Date()
    date.setDate(date.getDate() - 7 * i)
    date.setDate(
      date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1)
    )

    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')

    weeks.unshift(`${day}/${month}`)
  }

  return weeks
}

export const getLastSixMonthsNames = (): string[] => {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]
  const today = new Date()
  let currentMonth = today.getMonth()

  const lastSixMonths = []

  for (let i = 0; i < 6; i++) {
    lastSixMonths.unshift(monthNames[currentMonth])
    currentMonth--
    if (currentMonth < 0) {
      currentMonth = 11 // If January (0) is reached, set to December (11)
    }
  }

  return lastSixMonths
}

export const getLastSixYears = (): string[] => {
  const years = []

  for (let i = 0; i < 6; i++) {
    const date = new Date()
    date.setFullYear(date.getFullYear() - i)

    const year = String(date.getFullYear())

    years.unshift(year)
  }

  return years
}
